import { HStack } from "@chakra-ui/react";
import {
  PaginationItems,
  PaginationNextTrigger,
  PaginationPrevTrigger,
  PaginationRoot,
} from "../ui/pagination";

interface Props {
  page: number;
  handlePageChange: (page: number) => void;
  pageSize: number;
  count: number;
}

export const PaginationComponent = ({
  page,
  handlePageChange,
  count,
  pageSize,
}: Props) => {
  return (
    <PaginationRoot
      page={page}
      onPageChange={(e) => handlePageChange(e.page)}
      paddingTop="20px"
      count={count}
      pageSize={pageSize}
      defaultPage={1}
    >
      <HStack>
        <PaginationPrevTrigger data-testid="prev-page-button" />
        <PaginationItems />
        <PaginationNextTrigger data-testid="next-page-button" />
      </HStack>
    </PaginationRoot>
  );
};
